import script from "./policy-document.vue?vue&type=script&lang=ts&setup=true"
export * from "./policy-document.vue?vue&type=script&lang=ts&setup=true"

import "./policy-document.vue?vue&type=style&index=0&id=77391187&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77391187"]])

export default __exports__